import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

const CATS = [
  {
    key: "engineering", title: "Engineering", span: "md:col-span-8",
    desc: "Subject-wise mechanical & core engineering — mathematics, thermo, SOM, design.",
    img: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxtZWNoYW5pY2FsJTIwZW5naW5lZXJpbmclMjBibHVlcHJpbnR8ZW58MHx8fHwxNzg1NjYzNTI2fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    key: "trading", title: "Trading", span: "md:col-span-4",
    desc: "Markets, technical analysis and F&O — taught by an active trader.",
    img: "https://images.unsplash.com/photo-1689732888407-310424e3a372?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxzdG9jayUyMG1hcmtldCUyMHRyYWRpbmclMjBjaGFydHxlbnwwfHx8fDE3ODU2NjM1MjZ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    key: "school", title: "School 1–12", span: "md:col-span-5",
    desc: "All boards, English medium — maths and science, class by class.",
    img: "https://images.unsplash.com/photo-1514369118554-e20d93546b30?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxoaWdoJTIwc2Nob29sJTIwc3R1ZGVudHMlMjBzdHVkeWluZ3xlbnwwfHx8fDE3ODU2NjM1MjZ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    key: "mba", title: "MBA Finance", span: "md:col-span-7",
    desc: "Corporate finance, valuation and investment analysis for postgraduates.",
    img: "https://images.unsplash.com/photo-1709534486708-fb8f94150d0a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxmaW5hbmNlJTIwYnVzaW5lc3MlMjBtb2Rlcm58ZW58MHx8fDE3ODU2NjM1MjZ8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const Categories = ({ courses, onSelect }) => {
  const count = (key) => courses.filter((c) => c.category === key).length;
  return (
    <section className="px-6 py-24 md:px-12 md:py-32" data-testid="categories-section">
      <div className="mx-auto max-w-[1600px]">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: EASE }}
          className="mb-4 text-xs font-medium uppercase tracking-[0.4em] text-brand"
        >
          Disciplines
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: EASE }}
          className="mb-16 max-w-3xl font-display text-4xl font-black uppercase leading-none tracking-tighter sm:text-5xl lg:text-6xl"
        >
          Four worlds. <span className="font-light text-zinc-500">One mentor.</span>
        </motion.h2>
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          {CATS.map((cat, i) => (
            <motion.button
              key={cat.key}
              data-testid={`category-card-${cat.key}`}
              onClick={() => onSelect(cat.key)}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ delay: i * 0.1, duration: 0.7, ease: EASE }}
              className={`group col-span-1 text-left ${cat.span}`}
            >
              <div className="relative overflow-hidden border border-white/10">
                <img
                  src={cat.img}
                  alt={`${cat.title} courses at PP Academy`}
                  className="aspect-[16/8] w-full object-cover opacity-70 transition-transform duration-700 ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
                <div className="absolute bottom-0 left-0 flex w-full items-end justify-between p-6 md:p-8">
                  <div>
                    <div className="text-xs uppercase tracking-widest text-zinc-400">{count(cat.key)} courses</div>
                    <div className="mt-1 font-display text-3xl font-black uppercase tracking-tighter md:text-4xl">{cat.title}</div>
                  </div>
                  <div className="flex h-12 w-12 items-center justify-center border border-white/20 transition-colors duration-300 group-hover:border-brand group-hover:bg-brand">
                    <ArrowUpRight size={18} />
                  </div>
                </div>
              </div>
              <p className="mt-4 max-w-md text-sm leading-relaxed text-zinc-500">{cat.desc}</p>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
};
